module.exports = __webpack_public_path__ + "static/media/Icon- male.09a52d16.svg";